import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {AppComponent} from './app.component';
import {DescreportmainComponent} from './descreportmain/descreportmain.component';
import {SampleselectComponent} from './sampleselect/sampleselect.component';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import {GetLIMSDataService} from './get-limsdata.service';
import {DESCMainService} from './DESC.main.service';
import {LoginComponent} from './login/login.component';
import { GlobalDataService } from './services/global-data.service';

@NgModule({
  declarations: [
    AppComponent,
    DescreportmainComponent,
    SampleselectComponent,
    LoginComponent
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    FormsModule
  ],
  providers: [GetLIMSDataService, DESCMainService, GlobalDataService,
    {provide: LocationStrategy, useClass: HashLocationStrategy}],
  bootstrap: [AppComponent]
})
export class AppModule { }
